import { EnvironmentProviders, importProvidersFrom, inject, Provider, provideEnvironmentInitializer } from '@angular/core';
import {
  ConnectionHttpService,
  SOFTLINE_SERVICE_HTTP,
  SOFTLINE_STORE_REMOTE_OBJECT_SERVICE,
  SoftlineObjectService,
  Store,
  StoreModule
} from '@softline/core';
import {SOFTLINE_FEATURE_TRANSLATION, TranslationStore,} from '@softline/ui-core';
import {default as de} from '../i18n/de.json';
import {
  ApplicationStore,
  SOFTLINE_FEATURE_APPLICATIONS,
} from '@softline/application';
import { provideModuleWidgets, SOFTLINE_WIDGET_OUTLET_DASHBOARD } from '@softapps/core';
import {
  SOFTLINE_FEATURE_WWS_KREDITLIMIT,
  SOFTLINE_PERMISSION_WWS_KREDITLIMIT, SOFTLINE_PERMISSION_WWS_KREDITLIMIT_WIDGET,
  WwsKreditlimitStore
} from "./kreditlimit.shared";
import {SOFTLINE_API_WWS_KREDITLIMIT} from './kreditlimit.api';

export const kreditlimitProviders: (Provider | EnvironmentProviders)[] = [
  provideEnvironmentInitializer(() => {
      const store = inject(Store);
      store.commit(
        SOFTLINE_FEATURE_TRANSLATION,
        TranslationStore.mutations.add,
        {
          module: 'Kreditlimit',
          language: 'de',
          translations: de,
        }
      );
    }),
  importProvidersFrom(
    StoreModule.forFeature({
      name: SOFTLINE_FEATURE_WWS_KREDITLIMIT,
      feature: WwsKreditlimitStore.feature,
      providers: [
        {
          provide: SOFTLINE_STORE_REMOTE_OBJECT_SERVICE,
          useFactory: (service: ConnectionHttpService) =>
            new SoftlineObjectService(service, SOFTLINE_API_WWS_KREDITLIMIT),
          deps: [SOFTLINE_SERVICE_HTTP],
        },
      ],
    })
  ),
  ...provideModuleWidgets([
    {
      outletNames: [SOFTLINE_WIDGET_OUTLET_DASHBOARD],
      group: 'wws',
      loadComponent: () =>
        import('./widgets/kreditlimit-widget/kreditlimit-widget.component').then(
          (m) => m.KreditlimitWidgetComponent
        ),
      permission: SOFTLINE_PERMISSION_WWS_KREDITLIMIT_WIDGET,
    },
  ]),
];
